module.exports = __webpack_public_path__ + "img/aygaz-conversion-club-infographic-04.45f6d7cd.jpg";